import { render, staticRenderFns } from "./pc_bind.vue?vue&type=template&id=fced0564&scoped=true"
import script from "./pc_bind.vue?vue&type=script&lang=js"
export * from "./pc_bind.vue?vue&type=script&lang=js"
import style0 from "./pc_bind.vue?vue&type=style&index=0&id=fced0564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fced0564",
  null
  
)

export default component.exports